<template>
	<div v-if="is('error')" class="error">Error fetching this competition.</div>
	<div v-else-if="is('loading')" class="loading">Loading...</div>
	<EventForm v-else edit v-model="event" @submit="onSubmit" :busy="is('submitting')" />
</template>

<script>
import EventForm from '@/forms/EventForm'
import { EventProvider } from '@/lib/dataProvider'
import state from '@/mixins/state'
import toast from '@/mixins/toast'
import { pick } from '@/lib/helpers'

export default {
	name: 'EditCompetition',
	data() {
		return {
			event: null,
		}
	},
	computed: {
		eventId() {
			return this.$route.params.id
		},
	},
	methods: {
		setEvent(event) {
			this.event = pick(
				event,
				'enabled',
				'name',
				'dates',
				'entryForm',
				'prizes',
				'leaderboards',
				'panels',
				'linkPrivacy',
				'linkTerms'
			)
		},
		async getEvent() {
			this.setState('loading')
			try {
				const event = await EventProvider.get(this.eventId)
				this.setEvent(event)
				this.setState('idle')
			} catch (err) {
				this.setState('error')
			}
		},
		async onSubmit() {
			if (this.isnt('submitting')) {
				this.setState('submitting')
				try {
					// Update competition
					const event = await EventProvider.update(this.eventId, this.event)
					this.toast(`Successfully updated the *${event.name}* competition.`)

					// Return to management page
					this.$router.push({ name: 'Manage Competitions' })
				} catch (err) {
					this.toastError(err.message || 'Failed to update the competition.')
				}
				this.setState('idle')
			}
		},
	},
	mounted() {
		this.getEvent()
	},
	mixins: [state(), toast],
	components: {
		EventForm,
	},
}
</script>
